<template>
  <section-page
    title="Appointment Defaults"
    is-short
  >
    <div class="mb-200">
      <p>Choose how you would like to be notified for an appointment reminder.</p>
    </div>

    <grid-row>
      <grid-column>
        <form-field-switch
          label="Send Text Reminder"
          v-model="textReminder"
        ></form-field-switch>

        <form-field-time-in-minutes
          label="Time Before Sending"
          v-model="form.time_before_text_appointment_reminder"
          :validation-errors="validationErrors.time_before_text_appointment_reminder"
          :disabled="!textReminder"
        ></form-field-time-in-minutes>
      </grid-column>

      <grid-column>
        <form-field-switch
          label="Send Email Reminder"
          v-model="emailReminder"
        ></form-field-switch>

        <form-field-time-in-minutes
          label="Time Before Sending"
          v-model="form.time_before_email_appointment_reminder"
          :validation-errors="validationErrors.time_before_email_appointment_reminder"
          :disabled="!emailReminder"
        ></form-field-time-in-minutes>
      </grid-column>
    </grid-row>

    <div class="flex flex-end">
      <button-default
        :loading="isSaving"
        @click="update"
      >
        Update
      </button-default>
    </div>
  </section-page>
</template>

<script>
import {FormMixin} from "../../../forms/forms.mixin";

export default {
  name: "ProfileAppointmentDefault",
  mixins: [FormMixin],
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isSaving: false,
      textReminder: false,
      emailReminder: false,
      form: {
        time_before_text_appointment_reminder: null,
        time_before_email_appointment_reminder: null,
      },
      validationErrors: {}
    }
  },
  mounted() {
    if (this.user.time_before_text_appointment_reminder !== null) {
      this.textReminder = true
      this.form.time_before_text_appointment_reminder = this.user.time_before_text_appointment_reminder
    }

    if (this.user.time_before_email_appointment_reminder !== null) {
      this.emailReminder = true
      this.form.time_before_email_appointment_reminder = this.user.time_before_email_appointment_reminder
    }
  },
  methods: {
    update() {
      let payload = {
        time_before_text_appointment_reminder: (this.textReminder) ? this.form.time_before_text_appointment_reminder : null,
        time_before_email_appointment_reminder: (this.emailReminder) ? this.form.time_before_email_appointment_reminder : null
      };

      this.isSaving = true;
      return this.$api.users.updateAppointmentDefaults(this.user.id, payload)
        .then((res) => {
          this.$buefy.toast.open({
            message: "User Appointment Defaults were saved",
            type: 'is-success'
          });

          return res;
        })
        .finally(() => this.isSaving = false);
    }
  }
}
</script>

<style scoped>

</style>
